import _get from 'lodash/get';

const thdCustomer = typeof window !== 'undefined' && _get(window, 'THDCustomer.default');

export default thdCustomer;
